import { Button, DialogActions, DialogContent, DialogTitle, Divider } from "@mui/material"
import Input from "components/controls/input"
import InputBlock from "components/controls/input-block"
import { useDialogStore } from "dialogs"
import { observer } from "mobx-react-lite"
import Tooltip from "pages/content/components/tooltip"
import { useMainStore } from "store"
import { useForm } from "utils/use-form"

const SchemaSettings = observer(({ schemaId }: { schemaId: string }) => {

  const mainStore = useMainStore()
  const scheme = mainStore.schemes.get(schemaId)!
  const form = useForm({
    name: scheme.data.name,
    slug: scheme.data.slug || "",
    description: scheme.data.description || "",
    slugSchema: scheme.data.slugSchema || "{prefix}.{site}.{slug}.{sectionId}.section"
  })

  const disabled = !form.get("name")

  const dialogStore = useDialogStore()
  const apply = () => {
    if (disabled) return
    scheme.setData({ ...scheme.data,
      name: form.get("name") || "",
      slug: form.get("slug") || "",
      description: form.get("description") || "",
      slugSchema: form.get("slugSchema") === "{prefix}.{site}.{slug}.{sectionId}.section"? "": form.get("slugSchema")
    })
    mainStore.saveSchema(scheme)
    dialogStore.close()    
  }

  const slugSchemaTooltip = `
{prefix} - Общий префикс ключей 
{site} - Slug сайта
{slug} - Slug схемы
{sectionId} - ID секции
`.trim()

  return (
    <>
      <DialogTitle>Настройки схемы</DialogTitle>
      <DialogContent sx={{ width: 550, pb: 1, "&>*:not(:last-child)": { mb: 0.5 } }}>
        <Input {...form.getProps("name")} label="Название схемы" placeholder="Новая схема" />
        <Input {...form.getProps("slug")} label="Slug схемы" placeholder="Slug схемы" />
        {/* <Select {...form.getProps("slugPosition")} label="Отображение slug сайта" options={slugOptions} keys={slugOptionsKeys}> </Select> */}
        <Divider sx={{ color: "text.disabled", py: 0.5, fontSize: 10 }}>Прочее</Divider>
        <Input 
          {...form.getProps("slugSchema")} 
          label={<> Построение ключа <Tooltip title={slugSchemaTooltip}/></>} 
          placeholder="По умолчанию" 
        />
        <InputBlock 
          {...form.getProps("description")} 
          multiline 
          placeholder="Описание для схемы" 
          sx={{ "textarea": { minHeight: 38, px: 0.5 }, borderRadius: "5px" }}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={disabled} variant="contained" color="secondary" sx={{ px: 6 }} onClick={apply}>
          Сохранить данные
        </Button>
      </DialogActions>
    </>
  )
})

export default SchemaSettings